import {
  SelectProps,
  Select as _Select,
} from '@rebass/forms/styled-components';
import { forwardRef } from 'react';

export const Select = forwardRef((props: SelectProps, ref) => (
  <_Select
    ref={ref}
    {...props}
    sx={{
      fontSize: '1em',
      borderRadius: 5,
      px: 2,
      py: 1,
      borderColor: 'gray20',
      color: 'text',
      ...(props.sx || {}),
    }}
  />
));

Select.displayName = 'Select';

export default Select;
